import { render, staticRenderFns } from "./InformationCard.vue?vue&type=template&id=11b52dfe"
import script from "./InformationCard.vue?vue&type=script&lang=js"
export * from "./InformationCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports